<template>
 
  <report-page
    :title="name"
    :history-available="false"
    :generate-button="false"
    :data-to-send="{}"
    :buttons-disabled="buttonsDisabled"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
   

    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list')
          "
          disableFuzzyMatching
        />
         
      </report-field>

      <report-field :field-name="$t(reportParameters[0].label)">
        
        <treeselect
          v-model="reportParameters[0].value"
          :options="networkStartingPointOptions"
          :load-options="getNetworkStartingPointOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              technicalSiteLocalDisabled ||
              !userHasPermissionToList('technical_local')
          "
          :disable-branch-nodes="true"
          disableFuzzyMatching
        />
      </report-field>
    </template>

    <template v-slot:customButton>
      
      <v-layout row justify-end>
        <v-btn
          @click="openReport"
          :disabled="buttonsDisabled"
          color="accent"
          style="margin: 10px 0"
        >
          <v-icon left>open_in_new</v-icon>
          <span style="text-transform: none; font-size: 12px">
            {{ $t("Generate") }}
          </span>
        </v-btn>
      </v-layout>
     
    </template>
    
  </report-page>
</template>

<script>
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";
import ReportField from "@/components/Home/Content/Tabs/Reports/ReportField";
import ReportPage from "@/components/Home/Content/Tabs/Reports/ReportPage";
import endpoints from "@/utils/endpoints";
import MeasurementsToolbar from "@/components/Home/Toolbars/MeasurementsToolbar";



export default {
  name: "NetworkMapReport",

  components: {
    ReportPage,
    ReportField,
    MeasurementsToolbar,
  },

  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      reportParameters: [
        {
          label: "NetworkStartingPoint",
          key: "technical_local",
          type: "text",
          value: undefined
        }
      ],
      
    };
  },

  computed: {
    buttonsDisabled() {
      return this.reportParameters[0].value === undefined;
    },

    technicalSiteLocalDisabled() {
      return this.selectedWorkspace === undefined;
    },
   
  },

  watch: {
    selectedWorkspace() {
      this.resetReportParameterValues(this.reportParameters, 0);

      this.networkStartingPointOptions = null;
    },
    
    clearMeasurements() {
      this.measurementsLayerSource.clear();
    }
  },

  mounted() {
    this.setWorkspaceField();
  },

  methods: {
    openReport() {
      let technicalLocalID = this.reportParameters[0].value;
      let workspaceID = this.selectedWorkspace;
      window.open(
        endpoints.FIBER_API_URL +
          "airband/" +
          "?tl_id=" +
          technicalLocalID +
          "&wp_id=" +
          workspaceID
      );
    },

    createTechnicalLocalOption(technicalLocal) {
      let technicalLocalLabel =
        technicalLocal.tl_technical_site_logical_type +
        " " +
        technicalLocal.tl_id;
      if (technicalLocal.tl_label && technicalLocal.tl_label !== "") {
        technicalLocalLabel += ": " + technicalLocal.tl_label;
      }
      return {
        id: technicalLocal.tl_id,
        label: technicalLocalLabel
      };
    },
     createMeasurementsLayer() {
      this.measurementsLayerSource = new VectorSource();
      return new VectorLayer({
        source: this.measurementsLayerSource,
        style: new Style({
          fill: new Fill({
            color: "rgba(255, 255, 255, 0.2)",
          }),
          stroke: new Stroke({
            color: "#ffcc33",
            width: 2,
          }),
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: "#ffcc33",
            }),
          }),
        }),
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/NetworkMap.vue